import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

export default function Specs() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('theProduct.Specs');
    const { locale } = useRouter();
    const items = new Array(16).fill(1);
    const tips_items = new Array(2).fill(1);

    return (
        <div className={`${styles.TheComp} sp-125w-common`}>
            <EfSpec />
            <div className="info center">
                <p className="title">{t('title')}</p>
            </div>
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li className="item" key={k}>
                        <p className="item-title">{t(`specs_title_${k + 1}`)}</p>
                        <p className="item-desc">
                            {t.rich(`specs_desc_${k + 1}`, {
                                space: (text: string) => <span className="item-space">{text}</span>,
                            })}
                        </p>
                    </li>
                ))}
            </ul>

            <div className="tips-box">
                {tips_items.map((item: any, index: number) => (
                    <p key={index} className="tip">
                        {t(`tip_${index + 1}`)}
                    </p>
                ))}
            </div>
        </div>
    );
}
